// extracted by mini-css-extract-plugin
export default {"checkbox-container":"Checkbox_checkbox-container__AJYx5"};